import { render, staticRenderFns } from "./FormBtn.vue?vue&type=template&id=4b48ecda&scoped=true"
import script from "./FormBtn.vue?vue&type=script&lang=js"
export * from "./FormBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b48ecda",
  null
  
)

export default component.exports